module.exports = __webpack_public_path__ + "static/img/image02.f3a8331.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sm/landingPage/image02.png
// module id = 763A
// module chunks = 0